export const getSwiperPanelStyles = () => ({
  swiperPanel: {
    height: '100%',
  },
});
